import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Flame, Timer, Repeat, Trophy } from 'lucide-react';
import { Reveal } from '../hooks/useReveal';
import { IMAGES, STATIONS } from '../data/mock';
import PageHero from '../components/PageHero';
import TrialCTA from '../components/TrialCTA';

const PILLARS = [
  { icon: Flame, title: 'Hybride par nature', text: "L'Hyrox mêle endurance (course) et force fonctionnelle. Un seul sport pour devenir complet." },
  { icon: Timer, title: 'Standardisé mondialement', text: 'Mêmes stations, mêmes distances partout dans le monde. Tu peux comparer ta perf à l’international.' },
  { icon: Repeat, title: 'Pour tous les niveaux', text: 'Du débutant au pro, chacun avance à son rythme avec des charges adaptées.' },
  { icon: Trophy, title: 'Esprit compétition', text: 'Une vraie discipline avec ses compétitions officielles dans les plus grandes villes.' },
];

export default function Hyrox() {
  return (
    <>
      <PageHero
        eyebrow="La discipline"
        title="C'est quoi"
        accent="l'Hyrox ?"
        img="functional"
        subtitle="Le sport de fitness en plein boom : 8 km de course entrecoupés de 8 stations fonctionnelles. Un format identique partout dans le monde, accessible à tous."
      />

      <section className="py-14 md:py-28 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 90}>
              <div className="hx-card rounded-md p-7 h-full">
                <div className="w-12 h-12 grid place-items-center bg-accent/10 border border-accent/30 rounded-md mb-5">
                  <p.icon size={22} className="text-accent" />
                </div>
                <h3 className="font-cond text-lg tracking-wide mb-2">{p.title}</h3>
                <p className="text-[var(--hx-muted)] text-sm leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-14 md:py-28 bg-[#0d0d0d]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal className="mb-12">
            <p className="hx-eyebrow mb-4">Le parcours</p>
            <h2 className="font-display text-4xl md:text-6xl leading-[0.95]">Les 8 stations officielles</h2>
          </Reveal>
          <div className="space-y-3">
            {STATIONS.map((s, i) => (
              <Reveal key={s.name} delay={(i % 4) * 60}>
                <div className="hx-card group rounded-md flex items-center gap-5 p-4 md:p-5">
                  <span className="font-display text-3xl md:text-4xl text-accent w-12 shrink-0">{String(i + 1).padStart(2, '0')}</span>
                  <img src={IMAGES[s.img]} alt={s.name} loading="lazy" decoding="async" className="w-16 h-16 md:w-20 md:h-20 rounded-md object-cover shrink-0" />
                  <div className="flex-1">
                    <h3 className="font-cond text-lg md:text-xl tracking-wide group-hover:text-accent transition-colors">{s.name}</h3>
                    <p className="text-[var(--hx-muted)] text-sm">{s.desc}</p>
                  </div>
                  <span className="font-cond text-xs tracking-widest text-[var(--hx-muted)] hidden md:block">+ 1 KM RUN</span>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-10 flex flex-wrap items-center gap-5">
            <Link to="/nos-cours" className="hx-btn">Découvrir nos cours <ArrowRight size={18} /></Link>
            <Link to="/programme-hyrox" className="font-cond tracking-wider text-accent inline-flex items-center gap-2 hover:underline">Le programme d'entraînement Hyrox <ArrowRight size={16} /></Link>
          </Reveal>
        </div>
      </section>

      <TrialCTA />
    </>
  );
}
